import { Navigate } from 'react-router-dom'

import { env } from 'src/config/env'
import { paths } from 'src/config/paths'
import { Loading } from 'src/shared/components/ui/miscellaneous/loading'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

const WHITE_LISTED_EMAILS = [
  'richard@askconrad.ai',
  'sheng@askconrad.ai',
  'olivia@grcmortgage.com',
  'sheng+3@askconrad.ai',
  'sheng+4@askconrad.ai',
  'sheng+5@askconrad.ai',
  'sheng+6@askconrad.ai',
]

/** Prevents the user from accessing the website if they are signed in as an agent */
export default function BlockEnterpriseGuard({ children }: { children: React.ReactNode }) {
  const { data: user, isPending } = useMyUserData()

  // Wait for user data to load before rendering the page.
  if (isPending) {
    return <Loading style="fullscreen" />
  }

  // Admins can access all the pages.
  let shouldBlock = user?.role === 'admin' ? false : true

  // Local users can access all the pages.
  if (shouldBlock && ['local'].includes(env.MODE)) {
    shouldBlock = false
  }

  // Check if the user is allowed to access the current path.
  if (shouldBlock) {
    const primaryEmail = user?.primaryEmail?.toLowerCase() || ''
    const isAllowed = WHITE_LISTED_EMAILS.includes(primaryEmail)
    if (isAllowed) {
      shouldBlock = false
    }
  }

  if (shouldBlock) {
    return <Navigate to={paths.alert.path} replace />
  }

  return <>{children}</>
}
